module.exports = __webpack_public_path__ + "img/image-3.8c3dd3b3.webp";